<div class="container" #container>
  @for (frame of options$ | async; track trackFrame($index, frame)) {
    <div class="frame"
      >
      <lib-print-frame-drawer [ratio]="ratio$ | async" [config]="frame.value" [context]="context"
        [photoId]="photoId$ | async"
        [skipImage]="ignoreImage"
        (click)="openFrame(frame.value)"
      [contextId]="contextId"></lib-print-frame-drawer>
      <div class="details">
        <div class="name">{{frame.value | printFrameName |async }}</div>
        <div class="price">{{frame.price | pricePicker  }}</div>
      </div>
      @if (((photoId$ | async) | getFramesCountInBasket:frame.value | async)=== 0) {
        <div class="addFirst">
          <lib-button icon-only (click)="add(frame.value,frame.price)">
            <mat-icon>add</mat-icon>
          </lib-button>
        </div>
      } @else {
        <div class="counter">
          <lib-button icon-only (click)="remove(frame.value)">
            <mat-icon>remove</mat-icon>
          </lib-button>
          <span>{{(photoId$ | async) | getFramesCountInBasket:frame.value | async}}</span>
          <lib-button icon-only (click)="add(frame.value,frame.price)">
            <mat-icon>add</mat-icon>
          </lib-button>
        </div>
      }
    </div>
  }

</div>
@if (scrollableRight | async) {
  <div class="next" (click)="goRight()">
    <mat-icon>
      navigate_next
    </mat-icon>
  </div>
}
@if (scrollableLeft$ | async) {
  <div class="prev" (click)="goLeft()">
    <mat-icon>
      navigate_before
    </mat-icon>
  </div>
}
